"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reviews = exports.comments = void 0;
var _reselect = require("reselect");
var _assets = require("../../utils/assets");
var assetsSelectors = _interopRequireWildcard(require("../assets/selectors"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var comments = exports.comments = (0, _reselect.createSelector)(assetsSelectors.asset, function (state) {
  return state.reviews.data;
}, function ($asset, $reviews) {
  if ($reviews && $asset) {
    var _$reviews$getGAMKey;
    return (_$reviews$getGAMKey = $reviews[(0, _assets.getGAMKey)($asset)]) === null || _$reviews$getGAMKey === void 0 ? void 0 : _$reviews$getGAMKey.comments;
  }
  return undefined;
});
var reviews = exports.reviews = (0, _reselect.createSelector)(assetsSelectors.asset, function (state) {
  return state.reviews.data;
}, function ($asset, $reviews) {
  if ($reviews && $asset) {
    return $reviews[(0, _assets.getGAMKey)($asset)];
  }
  return undefined;
});
//# sourceMappingURL=selectors.js.map